module.exports = __webpack_public_path__ + "static/media/goldenCircle.4a5d85ef.png";